import { ISlot, Signal } from "signals.js";

export class GGSTextFieldSignal extends Signal {
    protected mappedEventType: string;
    public removed: Function;
    public added: Function;

    public remove(listener: Function): ISlot {
        this.removed.apply(null, [this.mappedEventType]);

        return super.remove(listener);
    }

    public add(listener: Function): ISlot {
        this.added.apply(null, [this.mappedEventType]);

        return super.add(listener);
    }
}
